import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'globalTypeIcon',
})
export class GlobalTypeIconPipe implements PipeTransform {
  transform(value: string) {
    switch (value) {
      case '32':
        return 'alberta-diagnosis';
      case '33':
        return 'alberta-dialysis';
      case '81':
        return 'alberta-body-size';
      case '58':
      case '108':
      case '164':
        return 'alberta-weight';
      case '147':
        return 'alberta-wound-location';
      case '160':
        return 'alberta-wound-bandage-change';
      case '159':
        return 'alberta-wound-load';
      case '158':
        return 'alberta-wound-permanent';
      case '165':
      case '166':
        return 'alberta-person';
      case '167':
        return 'alberta-customer-number';
      case '168':
        return 'alberta-birthday';
      case '169':
        return 'alberta-region';
      case '170':
        return 'alberta-person';
      case '171':
        return 'alberta-clock';
      case '172':
        return 'alberta-signature';
      default:
        return 'alberta-dot';
    }
  }
}
